import { AutoComplete, ConfigProvider, Spin, Tooltip } from 'antd';
import React, { useContext, useEffect, useRef, useState } from 'react';
import './customAutoComplete.less';
import { IoMdCloseCircle } from 'react-icons/io';
import ArrowSVG from '../../assets/ArrowSVG';
import { BaseOptionType, DefaultOptionType } from 'antd/lib/select';
import {
  useGetAirport,
  useGetAirportAutoComplete,
} from '@skygroup/shared/API/autoCompleteApi/autoCompleteApi';
import { useSelector } from 'react-redux';
import { RootState } from '../../../../store/store';
import {
  AUTOCOMPLETE_TYPE,
  removeDuplicateAutocomplete,
} from '@skygroup/shared/API/autoCompleteApi/autoCompleteUtils';
import { AirportElement } from './AirportElement';

interface CustomAutoCompleteProps
  extends React.ComponentProps<typeof AutoComplete> {
  width?: string;
  placeholder?: string;
  iataCode: string | null;
  options: BaseOptionType[] | DefaultOptionType[];
  selectedAirportFromConfig?: any;
  hideArrow?: boolean;
  selectedAirport: any;
  setSelectedAirport: any;
}

const CustomAutoCompleteAirport: React.FC<CustomAutoCompleteProps> = ({
  width,
  placeholder,
  iataCode,
  options,
  selectedAirportFromConfig,
  hideArrow = false,
  selectedAirport,
  setSelectedAirport,
  ...autoCompleteProps
}) => {
  const { searchDatePicker: t } = useSelector(
    (state: RootState) => state.config.translations
  );
  // const { direction } = useContext(ConfigProvider.ConfigContext);
  const { direction } = useSelector((data: RootState) => data.config);
  const correctOptions = options?.map((airport: any) => {
    return {
      value: airport.value,
      location_id: airport.location_id,
      name: airport.city_name,
      label: (
        <AirportElement
          data={airport}
          // label={airport.label}
          // value={airport.value}
        />
      ),
    };
  });
  const [searchValue, setSearchValue] = useState('');
  const [filteredOptions, setFilteredOptions] = useState(correctOptions);

  const [isShowSearchValue, setIsShowSearchValue] = useState(false);
  const { currentLang } = useSelector((data: RootState) => data.config);

  const { data, isFetching } = useGetAirportAutoComplete(
    searchValue,
    currentLang
  );

  const { data: singleAirport, refetch: refetchSingleAirport } = useGetAirport(
    iataCode ?? ''
  );

  useEffect(() => {
    !selectedAirportFromConfig && iataCode && refetchSingleAirport();
  }, []);

  useEffect(() => {
    if (singleAirport?.data && !selectedAirport) {
      setSelectedAirport({
        value: singleAirport.data.iata_code,
        location_id: singleAirport?.data?.location_id,
        name: singleAirport?.data?.city_name,
        label: (
          <AirportElement
            data={singleAirport.data}
            // label={singleAirport.data.city_name}
            // value={singleAirport.data.iata_code}
          />
        ),
      });
    }
  }, [iataCode, singleAirport]);

  useEffect(() => {
    if (!searchValue || !data?.data) return;
    const airports = removeDuplicateAutocomplete(
      data?.data,
      AUTOCOMPLETE_TYPE.AIRPORT
    ).map((airport: any) => {
      return {
        value: airport.iata_code,
        location_id: airport.location_id,
        name: airport.city_name,
        label: (
          <AirportElement
            data={airport}
            // label={airport.city_name}
            // value={airport.iata_code}
          />
        ),
      };
    });
    setFilteredOptions(airports);
  }, [data, searchValue]);

  return (
    <div className="custom-auto-complete-wrapper">
      <div className="custom-auto-complete" style={{ width }}>
        <span className="placeholder">
          {placeholder}
          {isFetching && <Spin />}
        </span>
        <AutoComplete
          popupClassName={`custom-auto-complete-dropdown ${
            isFetching ? 'custom-auto-complete-loading' : ''
          } direction-${direction ?? ''}`}
          style={{ minWidth: 'unset' }}
          {...autoCompleteProps}
          dropdownMatchSelectWidth={300}
          clearIcon={<IoMdCloseCircle size={20} />}
          onSelect={(value, wholeObject) => {
            setSelectedAirport(wholeObject);
            autoCompleteProps &&
              autoCompleteProps?.onSelect?.(value, wholeObject);
            setIsShowSearchValue(false);
            setSearchValue('');
          }}
          onFocus={() => {
            if (isShowSearchValue) {
              setSearchValue('');
              setIsShowSearchValue(true);
            }
          }}
          onSearch={(e) => {
            setIsShowSearchValue(true);
            setSearchValue(e);
          }}
          onBlur={() => {
            const value = autoCompleteProps.value as string;
            setSearchValue(value);
            setIsShowSearchValue(false);
          }}
          onDropdownVisibleChange={(e) => {
            if (e) setFilteredOptions(correctOptions);
          }}
          open={autoCompleteProps.open || undefined}
          value={isShowSearchValue ? searchValue : undefined}
          options={filteredOptions}
          autoFocus
        >
          {isShowSearchValue ? (
            searchValue
          ) : (
            <div
              onClick={() => {
                setIsShowSearchValue(true);
              }}
            >
              {selectedAirport?.label ?? t.searchDestination}
            </div>
          )}
        </AutoComplete>
      </div>
      {!hideArrow && <ArrowSVG />}
    </div>
  );
};

export default CustomAutoCompleteAirport;
